"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var misc_module_1 = require("./misc.module");
exports.BhtpMiscModule = misc_module_1.BhtpMiscModule;
__export(require("./modals"));
__export(require("./acknowledgements"));



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/index.js